import { useId, useState } from 'react'
import { ChevronDown } from 'lucide-react'
import { stepLine, trailLines, trailSummary, type TrailStep } from '../../lib/chatClient'

/**
 * What a finished turn did, as one quiet line — "Looked · read 3 ·
 * searched 2" — that opens on a tap into the steps and what each came
 * to ("12 cards", "nachtkritik.de, tagesspiegel.de"). WP 9.12.
 *
 * Drawn only once the turn is over: while it runs, `Status` is the live
 * line and this would say the same thing twice. Past turns draw it the same
 * way from their persisted `trail` part. A turn that ran no tool has no
 * steps and draws nothing — "answered from what it already had" is not
 * worth a line.
 */
export function Trail({ steps }: { steps: readonly TrailStep[] }) {
  const [open, setOpen] = useState(false)
  const listId = useId()
  const summary = trailSummary(steps)
  if (!summary) return null
  return (
    <div className="chat-trail">
      <button
        type="button"
        className="chat-fold"
        aria-expanded={open}
        aria-controls={listId}
        onClick={() => setOpen(o => !o)}
      >
        <span className="chat-fold__text">{summary}</span>
        <ChevronDown className="chat-fold__chev" aria-hidden="true" />
      </button>
      {open && (
        <ol id={listId} className="chat-trail__steps">
          {trailLines(steps).map((l, i) => (
            <li key={i}>
              {stepLine(l)}
              {l.details.length > 0 && <span className="chat-trail__detail"> · {l.details.join(' · ')}</span>}
            </li>
          ))}
        </ol>
      )}
    </div>
  )
}
